var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.editor,staticClass:"editor",staticStyle:{"width":"100%","max-width":"1200px"}})}
var staticRenderFns = []

export { render, staticRenderFns }